



































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from '@/store/entities/page-request'
import CreateSession from "../../../store/entities/createhandoversession";
import PackageInfo from "../../../store/entities/handoversessionpackageinfo";
import ListMixin from "@/components/mixin/handover-session-package-mixin";
import { mixins } from "vue-class-component";
import packageColumns from './handoversession-package-columns'
import _ from 'lodash';    
import AppConsts from "../../../lib/appconst";
import util from "../../../lib/util";
 class  PageCreateSessionRequest extends PageRequest{
        uncompletedObjectOnly: boolean=false;
        keyword: string="";
}
@Component
export default class CreateHandoverSession extends mixins(ListMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  namespace = "handoverSessionPackages";
  pagerequest:PageCreateSessionRequest=new PageCreateSessionRequest();
  refTypeCode: string= "";
  clientCode : string="";
  tplCode: string="";
  code: string="";
  currentRefTypeCode :string = "";
  itemTypeCode:string ="";
  currentItemTypeCode : string = "";
  spinShow:boolean = false;
  note:string="";
  tplName :string="";
  clientName:string="";
  get store() {
    return this.$store.state.handoverSessionPackages;
  }
  get sessionTypes(){
      var re = this.$store.state.handoverSession.sessionTypes;
      this.refTypeCode = re.length === 0 ? "" : re[0].code;
      this.currentRefTypeCode = this.refTypeCode;
      return re;
  }
  get sessionItemTypes(){
     var re= this.$store.state.handoverSession.sessionItemTypes;
     this.itemTypeCode = re.length === 0 ? "" : re[0].code;
     return re;
  }
  onGoBack(){
          this.$root.$router.push({name: 'handoversession'});
  }
  isRefTypeClient()
  {
    return this.refTypeCode == AppConsts.refType.Client;
  }
  isRefTypeTpl()
  {
    return this.refTypeCode == AppConsts.refType.Tpl;
  }
  deliveryPackagesHasItems()
  {
      return this.store.deliveryPackages.length>0;
  }
  resetRefCode()
  {
    this.tplCode="";
    this.tplName ="";
    this.clientCode="";
    this.clientName ="";
  }
  getRefCode()
  {
       var refCode = this.tplCode;
        if(this.isRefTypeClient())
        {
          refCode = this.clientCode
        }
        return refCode;
  }
  changeItemType()
  {
      if(util.isEmpty(this.currentItemTypeCode))
      {
        this.currentItemTypeCode = this.itemTypeCode;
      }
      else
      {
          if(this.currentItemTypeCode!=this.itemTypeCode && this.store.deliveryPackages.length>0)
          {
               this.$Modal.confirm({
                  title: this.L('Tips'),
                  content: this.L('Confirm.HandoverSession.ChangeItemType'),
                  okText: this.L('Yes'),
                  onOk: async () => {
                     this.$store.commit({
                        type: "handoverSessionPackages/resetList"
                      });
                      this.resetRefCode();
                  },
                  onCancel: ()=>{
                    this.itemTypeCode = this.currentItemTypeCode;
                  }
                })
          }
      }
  }
  changeRefType()
  {
      if(util.isEmpty(this.currentRefTypeCode))
      {
        this.currentRefTypeCode = this.refTypeCode;
      }
      else
      {
          if(this.currentRefTypeCode!=this.refTypeCode && this.store.deliveryPackages.length>0)
          {
               this.$Modal.confirm({
                  title: this.L('Tips'),
                  content: this.L('Confirm.HandoverSession.ChangeRefType'),
                  okText: this.L('Yes'),
                  cancelText: this.L('No'),
                  onOk: async () => {
                     this.$store.commit({
                        type: "handoverSessionPackages/resetList"
                      });
                      this.resetRefCode();
                  },
                  onCancel: ()=>{
                    this.refTypeCode = this.currentRefTypeCode;
                  }
                })
          }
      }
  }
  async scancode()
  {
    this.spinShow = true;
    try {
        var code = this.code;
        this.code = "";
        var refCode = this.getRefCode();
        await this.getItems(0,code,refCode,this.refTypeCode,this.itemTypeCode);
        this.spinShow= false;
    } catch (error) {
        this.spinShow= false;
    }
  }
  afterPushAndOrderPackages()
  {
      if(this.isRefTypeClient())
        this.getClientCodeFromItem();
      else
        this.getTplCodeFromItem();
  }
  afterRemove()
  {
      if(Util.isNull(this.store.deliveryPackages) || this.store.deliveryPackages.length<=0)
      {
          this.resetRefCode();
      }
  }
  getTplCodeFromItem()
  {
      this.tplCode = this.store.deliveryPackages[0].tplCode;
      this.tplName = this.store.deliveryPackages[0].tplName
  }
  getClientCodeFromItem()
  {
      this.clientCode = this.store.deliveryPackages[0].clientCode;
      this.clientName = this.store.deliveryPackages[0].clientName
  }
  async save() {
    this.$Modal.confirm({
          title:this.L('Tips'),
          content:this.L('Confirm.CreateHandoverSession'),
          okText:this.L('Yes'),
          cancelText:this.L('No'),
          onOk:async()=>{
            this.spinShow = true;
            try {
                var refCode = this.getRefCode();
                var deliveryPackageCodes = this.store.deliveryPackages.map((item) => item.packageNo);
                var data = {
                    refCode : refCode,
                    refTypeCode : this.refTypeCode,
                    itemType : this.itemTypeCode,
                    note: this.note,
                    deliveryPackageCodes : deliveryPackageCodes
                };
                await this.$store.dispatch({
                  type: "handoverSession/create",
                  data: data
                }) 
                .then(result => {
                  Util.showSuccessMsg(this,"Success.CreateHandoverSession");
                  this.reset();
                   this.$root.$router.push({name: 'view-handoversession/:id', params: {id: result.id}})
                });
                this.spinShow = false;
            } catch (error) {
                this.spinShow= false;
            }
          }
    });
  }
  reset()
  {
    this.pagerequest = new PageCreateSessionRequest();
    this.refTypeCode= "";
    this.resetRefCode();
    this.code="";
    this.currentRefTypeCode="";
    this.itemTypeCode = "";
    this.currentItemTypeCode ="";
     this.$store.commit({
      type: "handoverSessionPackages/resetList"
    });
  }
  columns= [
    ...packageColumns
    ,{
        title: Util.L('Action'),
        slot: 'action',
        align: 'center',
        width: 100
    }]
  async created(){
      this.spinShow= true;
      try {
        this.reset();
        await this.$store.dispatch({
            type:'handoverSession/getSessionTypes'
        });
        await this.$store.dispatch({
            type:'handoverSession/getSessionItemTypes'
        });
        this.spinShow = false;
      } catch (error) {
        this.spinShow = false;
      }
  }
  sessionRule = {
    itemTypeCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("ItemType")),
        trigger: "blur"
      }
    ],
    refTypeCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Type")),
        trigger: "blur"
      }
    ]
  };
}
